const natureEmojis = {
  fire: '🔥',
  flame: '🔥',
  hot: '🔥',
  lit: '🔥',
  snapstreak: '🔥'
}

module.exports = natureEmojis
